var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F64250",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 71.313a5.758 5.758 0 110-11.517 5.758 5.758 0 010 11.517M50.996 51.505a2.065 2.065 0 01-2.058 1.892h-3.877a2.065 2.065 0 01-2.058-1.892l-2.215-26.582a2.064 2.064 0 012.057-2.235h8.308a2.064 2.064 0 012.058 2.236l-2.215 26.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 4C23.29 4 4 23.29 4 47s19.29 43 43 43 43-19.29 43-43S70.71 4 47 4m0 90C21.084 94 0 72.916 0 47S21.084 0 47 0s47 21.084 47 47-21.084 47-47 47"
  }))));
}
export default __webpack_public_path__ + "error.e0fb12a8.svg";
export { SvgError as ReactComponent };